module.exports = __webpack_public_path__ + "img/Accura_logo_design_white.fa81f0af.svg";